import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi';
import { UserMappingAddEditSchema } from '../UserMappingSchema';
import { validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { use } from 'react';
import { MultiSelect } from "../../../Common/multiSelect";

const screenCode = 'USERMAPPING';

export function UserMappingAddEdit(props) {
    const { data, edit } = props.location;
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [allowedEstates, setAllowedEstates] = useState([]);
    const [cashWorkTypes, setCashWorkTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [mappingArray, setMappingArray] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [users, setUsers] = useState();
    const [isFailedData, setIsFailedData] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isUpdate, setIsUpdate] = useState(false);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [isEnable, setIsEnable] = useState(true);
    const [userMappingData, setuserMappingData] = useState({
        groupID: '0',
        estate: '0',
        userRole: '0',
        user: '0',
        allowOperationEntities: [],
        isActive: true,
    });
    const updatedArray = [];
    useEffect(() => {
        if (userMappingData.estate !== '0' && Object.keys(estates).length > 0 &&
            userMappingData.userRole !== '0' && userMappingData.user !== '0') {
            const getFilteredEstates = async () => {
                const filteredEstates = await services.GetAllOperationEntityByGroupID(userMappingData.groupID);
                const model = {
                    groupID: parseInt(userMappingData.groupID),
                    estate: parseInt(userMappingData.estate),
                    userRole: parseInt(userMappingData.userRole),
                    user: parseInt(userMappingData.user),
                };

                let alreadyMapped = [];
                try {
                    const response = await services.searchUserMappings(model);
                    if (Array.isArray(response)) {
                        alreadyMapped = response;
                    } else if (response && Array.isArray(response.data)) {
                        alreadyMapped = response.data;
                    } else if (response && response.statusCode === "Success" && Array.isArray(response.data)) {
                        alreadyMapped = response.data;
                    }
                } catch (error) {
                    console.error("Error fetching already mapped entities:", error);
                    alreadyMapped = [];
                }
                const filtered = Object.entries(filteredEstates).reduce((acc, [key, value]) => {
                    if (key !== userMappingData.estate) acc[key] = value;
                    return acc;
                }, {});

                const finalFiltered = Object.entries(filtered).reduce((acc, [key, value]) => {
                    const isAlreadyMappedInDB = alreadyMapped.length > 0 && alreadyMapped.some(mapping =>
                        mapping.allowOperationEntity == key ||
                        mapping.allowOperationEntityID == key ||
                        mapping.operationEntityID == key
                    );

                    const isAlreadyMappedInSession = mappingArray.some(mapping =>
                        mapping.groupID == userMappingData.groupID &&
                        mapping.operationEntityID == userMappingData.estate &&
                        mapping.userRole == userMappingData.userRole &&
                        mapping.user == userMappingData.user &&
                        mapping.allowOperationEntity == key
                    );

                    if (!isAlreadyMappedInDB && !isAlreadyMappedInSession) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                setAllowedEstates(finalFiltered);
            };
            getFilteredEstates();
        }
    }, [userMappingData.estate, userMappingData.groupID, userMappingData.userRole, userMappingData.user, estates, mappingArray]);


    const schema = Joi.object(UserMappingAddEditSchema).options({ allowUnknown: true });
    useEffect(() => {
        trackPromise(getPermissions());
        getAllGroups();
        GetAllCashWorkType();
    }, []);

    const handleMultiSelectChange = (selectedOptions) => {
        setuserMappingData(prev => ({
            ...prev,
            allowOperationEntities: selectedOptions
        }));
        if (selectedOptions && selectedOptions.length > 0) {
            const error = { ...errors };
            delete error['allowOperationEntities'];
            setErrors(error);
        }
    };

    useEffect(() => {
        if (userMappingData.groupID !== '0') {
            const getEstatesForDropdown = async () => {
                try {
                    const token = tokenService.getUserDetailsFromTokenV2();
                    if (!token || !token.operationEntities || token.operationEntities.length === 0) return;
                    const allEstates = await services.getEstatesByGroupID(userMappingData.groupID);
                    const estateMap = {};
                    for (const item of Object.entries(token.operationEntities)) {
                        const entity = item[1];
                        estateMap[entity.OperationEntityID] = entity.OperationEntityName;
                    }
                    const filteredEstates = {};

                    if (Array.isArray(allEstates)) {
                        for (let i = 0; i < allEstates.length; i++) {
                            const item = allEstates[i];
                            if (!item) continue;
                            if (typeof item === 'string') {
                                const matchingEntityId = Object.keys(estateMap).find(id =>
                                    estateMap[id] === item
                                );
                                if (matchingEntityId) {

                                    filteredEstates[matchingEntityId] = item;
                                }
                            }
                            else if (item && typeof item === 'object' && item.OperationEntityID) {
                                if (estateMap[item.OperationEntityID]) {
                                    filteredEstates[item.OperationEntityID] = item.OperationEntityName;
                                }
                            }
                        }
                    }
                    setEstates(filteredEstates);


                } catch (error) {
                }
            };
            getEstatesForDropdown();
        }
    }, [userMappingData.groupID]);

    useEffect(() => {
        if (userMappingData.estate !== '0') {
            getDivisionsForDropDown();
        }
    }, [userMappingData.estate]);

    useEffect(() => {
        if (data !== undefined) {
            let cashWorkTypeMappingID = data.cashWorkTypeMappingID
            if (cashWorkTypeMappingID != 0) {
                trackPromise(getuserMappingDataById(cashWorkTypeMappingID))
            }
        }
    }, [data]);
    useEffect(() => {
        if (userMappingData.estate !== '0') {
            trackPromise(GetUserRoles());
        }
    }, [userMappingData.estate]);

    useEffect(() => {
        trackPromise(getEstatesForDropdown());
    }, [userMappingData.groupID]);

    useEffect(() => {
        if (userMappingData.userRole !== '0') {
            trackPromise(GetActiveAspNetUser());
        }
    }, [userMappingData.userRole]);



    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'ADDEDITUSERMAPPING');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            setuserMappingData({
                ...userMappingData,
                groupID: token.groupID,
            })
        }
        else {
            setuserMappingData({
                ...userMappingData,
                groupID: token.groupID,
                estate: token.operationEntityID
            })
        }
        if (isUpdate === false) {
            setuserMappingData({
                ...userMappingData,
                groupID: token.groupID,
                estate: token.operationEntityID
            });
        }
    }

    async function getuserMappingDataById(cashWorkTypeMappingID) {
        let response = await services.GetuserMappingDataById(cashWorkTypeMappingID);
        let data = response.data[0];
        setIsUpdate(true);

        const formatDateString = (dateStr) => {
            const date = new Date(dateStr);
            return date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0');
        };

        setuserMappingData(prev => ({
            ...prev,
            groupID: data.groupID,
            estate: data.operationEntityID,
            divisionID: data.collectionPointID,
            cashWorkTypeID: data.cashWorkTypeID,
            fromDate: formatDateString(data.fromDate),
            toDate: formatDateString(data.toDate),
        }));
    }

    const handleChange = (e) => {
        validateInputs(e.target);
        if (e.target.name === "groupID") {
            setMappingArray([]);
            setuserMappingData({
                ...userMappingData,
                [e.target.name]: e.target.value,
                estate: '0',
            });
            setMultipleEstates([]);
        }
        else if (e.target.name === "estate") {
            setMappingArray([]);
            const selectedEstateID = e.target.value;

            setuserMappingData({
                ...userMappingData,
                estate: selectedEstateID,
                userRole: '0',
                user: '0',
                allowOperationEntity: '0',
                allowOperationEntities: [] // Clear selected entities when estate changes
            });
        } else if (e.target.name === "userRole") {
            setuserMappingData({
                ...userMappingData,
                [e.target.name]: e.target.value,
                user: '0',
                allowOperationEntities: [] // Clear selected entities when user role changes
            });
        } else if (e.target.name === "user") {
            setuserMappingData({
                ...userMappingData,
                [e.target.name]: e.target.value,
                allowOperationEntities: [] // Clear selected entities when user changes
            });
        } else if (e.target.name === "allowOperationEntity") {
            setuserMappingData({
                ...userMappingData,
                [e.target.name]: e.target.value
            });
        }
    };

    function handleActiveChange(target) {
        validateInputs(target);

        setuserMappingData({
            ...userMappingData,
            [target.name]: target.checked
        });
    }

    async function handleAdd(e) {
        e.preventDefault();
        const formDataForValidation = {
            ...userMappingData,
            allowOperationEntities: userMappingData.allowOperationEntities.length > 0
                ? userMappingData.allowOperationEntities
                : null
        };

        const errorMessages = validate(schema, formDataForValidation);
        setErrors(errorMessages || {});

        if (errorMessages && Object.keys(errorMessages).length > 0) {
            return;
        }


        if (isUpdate == true) {
            const updateModel = {
                cashWorkTypeMappingID: parseInt(data.cashWorkTypeMappingID),
                groupID: parseInt(userMappingData.groupID),
                operationEntityID: parseInt(userMappingData.estate),
                collectionPointID: parseInt(userMappingData.divisionID),
                cashWorkTypeID: parseInt(userMappingData.cashWorkTypeID),
                fromDate: userMappingData.fromDate,
                toDate: userMappingData.toDate,
                isActive: userMappingData.isActive,
                createdBy: parseInt(tokenService.getUserIDFromToken()),
                allowedOperationEntities: userMappingData.allowOperationEntities
                    .map(e => e.value)
                    .join(',')
            };

        } else {
            const newMappings = [];
            let hasDuplicates = false;
            userMappingData.allowOperationEntities.forEach(entity => {
                const baseModel = {
                    groupID: parseInt(userMappingData.groupID),
                    operationEntityID: parseInt(userMappingData.estate),
                    userRole: parseInt(userMappingData.userRole),
                    user: parseInt(userMappingData.user),
                    allowOperationEntity: parseInt(entity.value),
                };
                const isDuplicate = mappingArray.some(element =>
                    element.groupID == baseModel.groupID &&
                    element.operationEntityID == baseModel.operationEntityID &&
                    element.userRole == baseModel.userRole &&
                    element.user == baseModel.user &&
                    element.allowOperationEntity == baseModel.allowOperationEntity
                );

                if (isDuplicate) {
                    hasDuplicates = true;
                } else {
                    newMappings.push({
                        ...baseModel,
                        isActive: userMappingData.isActive,
                        createdBy: parseInt(tokenService.getUserIDFromToken()),
                        createdDate: new Date().toISOString(),
                        groupName: groups[userMappingData.groupID],
                        estateName: estates[userMappingData.estate],
                        userRoleName: userRoles[userMappingData.userRole],
                        userName: users[userMappingData.user],
                        allowOperationEntityName: allowedEstates[entity.value],
                        remark: ""
                    });
                }
            });

            if (hasDuplicates) {
                setMessageModel({
                    hidden: false,
                    type: "Error",
                    disciption: "Some entries were duplicates and weren't added"
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Error", disciption: "" });
                }, 4000);
            }

            if (newMappings.length > 0) {
                setMappingArray(prev => [...prev, ...newMappings]);
                setIsTableHidden(false);
            }

            setuserMappingData({
                ...userMappingData,
                isActive: true,
                userRole: '0',
                user: '0',
                allowOperationEntities: [],
            });
        }
    }
    const DeleteDetails = (row) => {
        const updatedArray = mappingArray.filter(item => item !== row);
        setMappingArray(updatedArray);
    };

    async function saveuserMappingData() {
        if (mappingArray.length > 0) {
            var response = await services.SaveuserMappingData(mappingArray);
            if (response.statusCode == "Success") {
                setMessageModel({
                    hidden: false,
                    type: "Success",
                    disciption: response.message || "User mapping data saved successfully."
                });
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Success", disciption: "" });
                }, 4000);
                setMappingArray([]);
                setuserMappingData({
                    ...userMappingData,
                    userRole: '0',
                    user: '0',
                    allowOperationEntity: '0',
                    isActive: true,
                });
                afterSuccessfulyChanged(response.statusCode);
            }
            else {
                setMessageModel({
                    hidden: false,
                    type: "Error",
                    disciption: response.message || "User mapping data Not saved."
                });
                setIsFailedData(true);


                for (let item of response.data.failedMappings) {
                    updatedArray.push(item);
                }
                setMappingArray(updatedArray);
                if (response.data.successCount > 0) {
                    setMessageModel({
                        hidden: false,
                        type: "Success",
                        disciption: `${response.data.successCount} records saved successfully.`
                    });
                }
                setTimeout(() => {
                    setMessageModel({ hidden: true, type: "Error", disciption: "" });
                }, 4000);
            }
        }
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function GetActiveAspNetUser() {
        var data = await services.GetActiveAspNetUser(userMappingData.userRole);
        setUsers(data);
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(userMappingData.groupID);
    }

    async function GetUserRoles() {
        const data = await services.GetUserRoles(userMappingData.estate);
        setUserRoles(data);
    }

    async function GetAllCashWorkType() {
        const data = await services.GetAllCashWorkType(userMappingData.cashWorkTypeID);
        setCashWorkTypes(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(userMappingData.estate);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearButton();
            setTimeout(() => {
                props.history.push({ pathname: '/UserMapping' });
            }, 1500);
        }
    }

    function clearButton() {
        setIsEnable(true);
        setuserMappingData({
            ...userMappingData,
            userRole: '0',
            user: '0',
            allowOperationEntities: [],
            isActive: true,
        });
        setMappingArray([]);
        setErrors({});
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={isUpdate ? "Edit User Mapping Data" : "Add User Mapping Data"}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/UserMapping"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled || isUpdate}
                                            value={userMappingData.groupID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="estate">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estate"
                                            id="estate"
                                            name="estate"
                                            disabled={!isEnable || !permissionList.isOperationEntityFilterEnabled || isUpdate}
                                            value={userMappingData.estate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="userRole">User Role *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="userRole"
                                            id="userRole"
                                            name="userRole"
                                            value={userMappingData.userRole}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select User Role--</MenuItem>
                                            {generateDropDownMenu(userRoles)}
                                        </Select>
                                        {errors["userRole"] && <FormHelperText error>{errors["userRole"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="user">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="user"
                                            id="user"
                                            name="user"
                                            value={userMappingData.user}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["user"] && <FormHelperText error>{errors["user"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="allowOperationEntities">Allow Operation Entities *</InputLabel>
                                        <MultiSelect
                                            items={Object.entries(allowedEstates).map(([value, label]) => ({ value, label }))}
                                            selectedValues={userMappingData.allowOperationEntities}
                                            placeholder="Select allowed entities"
                                            selectAllLabel="Select all"
                                            noOptionsText="No options available"
                                            onToggleOption={handleMultiSelectChange}
                                            onClearOptions={() => handleMultiSelectChange([])}
                                            onSelectAll={(isSelected) =>
                                                isSelected ?
                                                    handleMultiSelectChange(Object.entries(allowedEstates).map(([value, label]) => ({ value, label }))) :
                                                    handleMultiSelectChange([])
                                            }
                                            getOptionLabel={(option) => option.label}
                                        />
                                        {errors["allowOperationEntities"] && <FormHelperText error>{errors["allowOperationEntities"]}</FormHelperText>}
                                    </div>

                                    <div className="form-group row w-100" style={{ marginTop: "10px", marginLeft: "10px" }}>
                                        <div className="col-md-3 pb-1">
                                            <InputLabel shrink htmlFor="isActive">Active</InputLabel>
                                            <input
                                                className="mr-2"
                                                id="isActive"
                                                switch="none"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleActiveChange(e.target)}
                                                checked={userMappingData.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes" data-off-label="No"></label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value={isUpdate ? "Update" : "Add"}
                                            disabled={!isEnable}
                                            onClick={handleAdd}
                                        />
                                    </div>
                                </div>
                                {mappingArray.length > 0 && (
                                    <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Estate</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>User</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>User Role</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Allowed Operation Entity</TableCell>
                                                        {isFailedData && (
                                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Remark</TableCell>
                                                        )}
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {mappingArray.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{row.estateName}</TableCell>
                                                            <TableCell align="center">{row.userName}</TableCell>
                                                            <TableCell align="center">{row.userRoleName}</TableCell>
                                                            <TableCell align="center">{row.allowOperationEntityName}</TableCell>
                                                            {isFailedData && (
                                                                <TableCell align="center">{row.remark}</TableCell>
                                                            )}
                                                            <TableCell align="center">
                                                                <IconButton onClick={() => DeleteDetails(row)}>
                                                                    <DeleteIcon color="error" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                            <div className="card-footer">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Save"
                                                    onClick={saveuserMappingData}
                                                />
                                                <input
                                                    type="reset"
                                                    className="btn btn-warning pull-right"
                                                    value="Clear"
                                                    onClick={clearButton}
                                                />
                                            </div>
                                        </TableContainer>
                                    </Box>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}